import React from 'react';
import './../App.css';
import X43Hull from './X43Hull';
import { Route, Switch, Redirect  } from "react-router-dom";
import X43BowSprit from './X43BowSprit';
import X43HullTreatment from './X43HullTreatment';
import X43Transom from './X43Transom';
import X43Deck from './X43Deck';
import X43Sprayhood from './X43Sprayhood';
import X43Wheel from './X43Wheel';
import X43Mast from './X43Mast';
import X43Interior from './X43Interior';
import X43Galley from './X43Galley';
import X43Fabric from './X43Fabric';
import X43Saloon from './X43Saloon';
import X43OwnersCabin from './X43OwnersCabin';
import X43AftCabin from './X43AftCabin';
import Logo from './x43-logo.svg';
import X43Summary from './X43Summary';
import X43BathingPlatform from './X43BathingPlatform';

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg';
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg';
import hullColor13 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x dark blue RAL 5011 waterlines.jpg';
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg';
import hullColor15 from '../assets/hullColors/Hull colour - black grey RAL 7021 & 3 x pure white RAL 9010 waterlines.jpg';

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg';
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg';
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg';
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg';
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg';
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg';
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg';
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg';
import fabric9 from '../assets/fabrics/AlsaceSand.jpg';
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg';

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg';
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg';

import veneer1 from '../assets/interiorColors/nordic_oak.jpg';
import veneer2 from '../assets/interiorColors/teak.jpg';

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg';
import laminate2 from '../assets/interiorColors/walnut.jpg';
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg';

import sprayhood1 from '../assets/sprayhoodColors/without.jpg';
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg';
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg';
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg';
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg';
import { withTranslation } from 'react-i18next';

import ConfiguratorContainer from '../ConfiguratorContainer';

class X43Container extends ConfiguratorContainer {
    constructor(props) {
        super(props);

        this.logo = Logo;
        this.logoLink = 'https://www.x-yachts.com/en/yachts/x/x4-3/';

        this.HullColourOptions = [
            { value: 1, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Light Grey (RAL 7035) integrated Gelcoat Water Lines'), preview: hullColor11 },
            { value: 2, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'), preview: hullColor12 },
            { value: 3, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x Dark Blue (RAL 5011) integrated Gelcoat Water Lines'), preview: hullColor13 },
            { value: 4, label: this.props.t('Light Grey'), description: this.props.t('(RAL 7035) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'), preview: hullColor14 },
            { value: 5, label: this.props.t('Black Grey'), description: this.props.t('(RAL 7021) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'), preview: hullColor15 }
        ];

        this.BowSpritOptions = [
            { value: 1, label: this.props.t('Standard GRP cowl'), description: this.props.t('(without bowsprit)') },
            { value: 2, label: this.props.t('Painted carbon fibre bow sprit'), description: this.props.t('(will match hull color)') },
            { value: 3, label: this.props.t('Clear coated carbon fibre bowsprit') }
        ];

        this.HullTreatmentOptions = [
            { value: 1, label: this.props.t('White') },
            { value: 2, label: this.props.t('Black') },
            { value: 3, label: this.props.t('Copper') }
        ];

        this.DeckOptions = [
            { value: 1, label: this.props.t('Genuine teak with black caulkings') },
            { value: 2, label: this.props.t('Flexiteek with grey stripes') }
        ];

        this.BathingPlatformOptions = [
            { value: 1, label: this.props.t('No bathing platform') },
            { value: 2, label: this.props.t('Bathing platform medium'), description: this.props.t('Foldable with mechanical hoisting system and attachment point for separate bathing ladder.')},
            { value: 3, label: this.props.t('Bathing platform large'), description: this.props.t('Foldable with mechanical hoisting system and attachment point for separate bathing ladder')}
        ];

        this.SprayhoodOptions = [
            { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
            { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
            { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
            { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
            { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
        ];

        this.BoomCoverOptions = this.SprayhoodOptions;

        this.WheelOptions = [
            { value: 1, label: this.props.t('Steel wheel') },
            { value: 2, label: this.props.t('Composite wheel black') },
            { value: 3, label: this.props.t('Composite wheel white') }
        ];

        this.MastAndBoomOptions = [
            { value: 1, label: this.props.t('Aluminium') },
            { value: 3, label: this.props.t('White painted carbon') },
            { value: 4, label: this.props.t('Black painted carbon') },
            { value: 2, label: this.props.t('Clear coated carbon') }
        ];

        this.VeneerOptions = [
            { value: 1, label: this.props.t('Nordic oak (standard)'), thumbnail: veneer1 },
            { value: 2, label: this.props.t('Modern Teak (optional)'), thumbnail: veneer2 }
        ];

        this.FloorboardOptions = [
            { value: 1, label: this.props.t('Teak laminate (standard)'), thumbnail: laminate1 },
            { value: 2, label: this.props.t('Walnut laminate (optional)'), thumbnail: laminate2 },
            { value: 3, label: this.props.t('Teak with inlay stripes / holly (optional)'), thumbnail: laminate3 }
        ];

        this.HandrailOptions = [
            { value: 1, label: this.props.t('No handrails') },
            { value: 2, label: this.props.t('Wooden laminated')},
            { value: 3, label: this.props.t('Stainless steel')}
        ];

        this.WorktopOptions = [
            { value: 1, label: this.props.t('Worktop in Camoan white Corian'), thumbnail: galley1 },
            { value: 2, label: this.props.t('Worktop in black quartz Corian'), thumbnail: galley2 }
        ];

        this.AftCabinLayoutOptions = [
            { value: 1, label: this.props.t('') },
            { value: 2, label: this.props.t('Upper shelves') },
            { value: 3, label: this.props.t('Freeboard hung sea berths') }
        ];

        this.FabricOptions = [
            { value: 1, label: this.props.t('Just Fleckless – 01 Nature'), thumbnail: fabric1 },
            { value: 2, label: this.props.t('Just Fleckless – 05 Camel'), thumbnail: fabric2 },
            { value: 3, label: this.props.t('Just Fleckless – 10 Navy'), thumbnail: fabric3 },
            { value: 4, label: this.props.t('Just Fleckless – 403 Bambus'), thumbnail: fabric4 },
            { value: 5, label: this.props.t('Just Fleckless – 710 Moon Grey'), thumbnail: fabric5 },
            { value: 6, label: this.props.t('Just Fleckless – 750 Olive Grey'), thumbnail: fabric6 },
            { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
            { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
            { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
            { value: 10, label: this.props.t('Nubilux 709 Argent'), thumbnail: fabric10 }
        ];

        this.state = Object.assign(this.state, {
            boat: "X43",
            exterior: {
                HullColour: this.HullColourOptions[0],
                BowSprit: this.BowSpritOptions[0],
                HullTreatment: this.HullTreatmentOptions[0],
                Deck: this.DeckOptions[0],
                TeakOnSideDecks: { value: 1, label: 'false' },
                TeakOnCoachroof: { value: 1, label: 'false' },
                BathingPlatform: this.BathingPlatformOptions[0],
                TeakOnBathingPlatform: { value: 2, label: 'true' },
                SprayHood: this.SprayhoodOptions[0],
                Wheel: this.WheelOptions[0],
                MastAndBoom: this.MastAndBoomOptions[0],
                BoomCover: this.BoomCoverOptions[0]
            },
            transom: {
                Name: {
                    verticalOffset: 270,
                    color: this.colorOptions[2],
                    value: 'My yacht',
                    font: this.fontOptions[0],
                    size: this.sizeOptions[2],
                    horizontalOffset: 0
                },
                Port: {
                    verticalOffset: 540,
                    color: this.colorOptions[2],
                    value: 'Port',
                    font: this.fontOptions[0],
                    size: this.sizeOptions[1],
                    horizontalOffset: 0
                }
            },
            interior: {
                Veneer:  this.VeneerOptions[0],
                Floorboard: this.FloorboardOptions[0],
                Handrail: this.HandrailOptions[0],
                Worktop: this.WorktopOptions[0],
                Fabric: this.FabricOptions[0],
                CupboardsSaloon: { value: 1, label: 'false' },
                CupboardsOwnersCabin: { value: 1, label: 'false' },
                FabricOwnersCabin: this.FabricOptions[0],
                FabricAftCabin: this.FabricOptions[0],
                AftCabinLayout: this.AftCabinLayoutOptions[0],
                Mast: this.MastAndBoomOptions[0]
            }
        });

        this.steps = [
            { name: this.props.t('Hull colourways'), url: '/x43/hull' },
            { name: this.props.t('Bowsprit'), url: '/x43/bowsprit' },
            { name: this.props.t('Hull treatment'), url: '/x43/hulltreatment' },
            { name: this.props.t('Deck'), url: '/x43/deck' },
            { name: this.props.t('Bathing platform'), url: '/x43/bathingplatform' },
            { name: this.props.t('Boat name'), url: '/x43/transom' },
            { name: this.props.t('Mast and boom'), url: '/x43/mast' },
            { name: this.props.t('Wheels'), url: '/x43/wheel' },
            { name: this.props.t('Sprayhood & Boom Cover'), url: '/x43/sprayhood' },

            { name: this.props.t('Interior surfaces'), url: '/x43/surfaces' },
            { name: this.props.t('Saloon furniture'), url: '/x43/saloon' },
            { name: this.props.t('Interior Fabric'), url: '/x43/fabric' },
            { name: this.props.t('Galley'), url: '/x43/galley' },
            { name: this.props.t('Owner\'s cabin'), url: '/x43/ownerscabin' },
            { name: this.props.t('Aft cabins'), url: '/x43/aftcabin' },
            
            { name: this.props.t('Summary'), url: '/x43/summary' }
        ];

        this.handleHullConfigurationChange = this.handleHullConfigurationChange.bind(this);
    }

    handleHullConfigurationChange(newConfiguration) {
        let transom = this.state.transom;
        switch (newConfiguration.HullColour.value) {
            case 1:
                transom.Name.color = this.colorOptions[2];
                transom.Port.color = this.colorOptions[2];
                break;
            case 2:
                transom.Name.color = this.colorOptions[3];
                transom.Port.color = this.colorOptions[3];
                break;
            case 3:
                transom.Name.color = this.colorOptions[4];
                transom.Port.color = this.colorOptions[4];
                break;
            case 4:
            case 5:
                transom.Name.color = this.colorOptions[1];
                transom.Port.color = this.colorOptions[1];
                break;
            default:
                break;

        }

        super.handleTransomChange(transom);
        super.handleExteriorConfigurationChange(newConfiguration);
    }

    handleExteriorConfigurationChange(newConfiguration) {
        let interior = this.state.interior;
        interior.Mast = newConfiguration.MastAndBoom;

        super.handleInteriorConfigurationChange(interior);
        super.handleExteriorConfigurationChange(newConfiguration);
    }




    generateCode() {
        let data = [];
        data.push("x43");

        data.push([]);
        let exterior = this.state.exterior;
        for (const key in exterior) {
            if (exterior.hasOwnProperty(key)) {
                let element = exterior[key].value;
                data[data.length - 1].push(element);
            }
        }

        data.push([]);
        data[data.length - 1].push([]);
        data[data.length - 1].push([]);

        let transom = this.state.transom;
        data[data.length - 1][0].push(transom.Name.value);
        data[data.length - 1][0].push(transom.Name.font.value);
        data[data.length - 1][0].push(transom.Name.size.value);
        data[data.length - 1][0].push(transom.Name.color.value);
        data[data.length - 1][0].push(transom.Name.horizontalOffset);
        data[data.length - 1][0].push(transom.Name.verticalOffset);

        data[data.length - 1][1].push(transom.Port.value);
        data[data.length - 1][1].push(transom.Port.font.value);
        data[data.length - 1][1].push(transom.Port.size.value);
        data[data.length - 1][1].push(transom.Port.color.value);
        data[data.length - 1][1].push(transom.Port.horizontalOffset);
        data[data.length - 1][1].push(transom.Port.verticalOffset);

        data.push([]);
        let interior = this.state.interior;
        for (const key in interior) {
            if (interior.hasOwnProperty(key)) {
                let element = interior[key].value;
                data[data.length - 1].push(element);
            }
        }
        
        var json = JSON.stringify(data);
        return btoa(json);
    }

    parseCode(code) {
        let json = JSON.parse(atob(code));

        if (json[0] !== 'x43') {
            return;
        }

        let exterior = this.state.exterior;
        exterior.HullColour = this.HullColourOptions.find(v => v.value === json[1][0]) || this.HullColourOptions[0];
        exterior.BowSprit = this.BowSpritOptions.find(v => v.value === json[1][1]) || this.BowSpritOptions[0];
        exterior.HullTreatment = this.HullTreatmentOptions.find(v => v.value === json[1][2]) || this.HullTreatmentOptions[0];
        exterior.Deck = this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0];
        exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' };
        exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' };
        exterior.BathingPlatform = this.BathingPlatformOptions.find(v => v.value === json[1][6]) || this.BathingPlatformOptions[0];
        exterior.TeakOnBathingPlatform = { value: +json[1][7] || 1, label: '' };
        exterior.SprayHood = this.SprayhoodOptions.find(v => v.value === json[1][8]) || this.SprayhoodOptions[0];
        exterior.Wheel = this.WheelOptions.find(v => v.value === json[1][9]) || this.WheelOptions[0];
        exterior.MastAndBoom = this.MastAndBoomOptions.find(v => v.value === json[1][10]) || this.MastAndBoomOptions[0];
        exterior.BoomCover = this.BoomCoverOptions.find(v => v.value === json[1][11]) || this.BoomCoverOptions[0];

        let transom = this.state.transom;
        transom.Name.value = json[2][0][0] || '';
        transom.Name.font = this.fontOptions.find(v => v.value === json[2][0][1]) || this.fontOptions[0];
        transom.Name.size = this.sizeOptions.find(v => v.value === json[2][0][2]) || this.sizeOptions[0];
        transom.Name.color = this.colorOptions.find(v => v.value === json[2][0][3]) || this.colorOptions[0];
        transom.Name.horizontalOffset = +json[2][0][4] || 1;
        transom.Name.verticalOffset = +json[2][0][5] || 1;

        transom.Port.value = json[2][1][0] || '';
        transom.Port.font = this.fontOptions.find(v => v.value === json[2][1][1]) || this.fontOptions[0];
        transom.Port.size = this.sizeOptions.find(v => v.value === json[2][1][2]) || this.sizeOptions[0];
        transom.Port.color = this.colorOptions.find(v => v.value === json[2][1][3]) || this.colorOptions[0];
        transom.Port.horizontalOffset = +json[2][1][4] || 1;
        transom.Port.verticalOffset = +json[2][1][5] || 1;
        
        let interior = this.state.interior;
        interior.Veneer = this.VeneerOptions.find(v => v.value === json[3][0]) || this.VeneerOptions[0];
        interior.Floorboard = this.FloorboardOptions.find(v => v.value === json[3][1]) || this.FloorboardOptions[0];
        interior.Handrail = this.HandrailOptions.find(v => v.value === json[3][2]) || this.HandrailOptions[0];
        interior.Worktop = this.WorktopOptions.find(v => v.value === json[3][3]) || this.WorktopOptions[0];
        interior.Fabric = this.FabricOptions.find(v => v.value === json[3][4]) || this.FabricOptions[0];
        interior.CupboardsSaloon = { value: +json[3][5] || 1, label: '' };
        interior.CupboardsOwnersCabin = { value: +json[3][6] || 1, label: '' };
        interior.FabricOwnersCabin = this.FabricOptions.find(v => v.value === json[3][7]) || this.FabricOptions[0];
        interior.FabricAftCabin = this.FabricOptions.find(v => v.value === json[3][8]) || this.FabricOptions[0];
        interior.AftCabinLayout = this.AftCabinLayoutOptions.find(v => v.value === json[3][9]) || this.AftCabinLayoutOptions[0];

        this.setState(this.state);
    }


    renderSteps() {
        return (
            <Switch location={this.props.location}>
                <Route exact path="/x43" render={() => <Redirect to="/x43/hull" />} />

                <Route path="/x43/hull" render={(props) => <X43Hull {...props} onChange={this.handleHullConfigurationChange} onCodeSubmitted={this.parseCode} configuration={this.state.exterior} transom={this.state.transom} hullColourOptions={this.HullColourOptions} />} />
                <Route path="/x43/bowsprit" render={(props) => <X43BowSprit {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} bowSpritOptions={this.BowSpritOptions} />} />
                <Route path="/x43/hulltreatment" render={(props) => <X43HullTreatment {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} hullTreatmentOptions={this.HullTreatmentOptions} />} />
                <Route path="/x43/transom" render={(props) => <X43Transom {...props} onChange={this.handleTransomChange} configuration={this.state.exterior} transom={this.state.transom} fontOptions={this.fontOptions} sizeOptions={this.sizeOptions} colorOptions={this.colorOptions} />} />
                <Route path="/x43/deck" render={(props) => <X43Deck {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} deckOptions={this.DeckOptions} />} />
                <Route path="/x43/bathingplatform" render={(props) => <X43BathingPlatform {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} bathingPlatformOptions={this.BathingPlatformOptions} />} />
                <Route path="/x43/sprayhood" render={(props) => <X43Sprayhood {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} sprayhoodOptions={this.SprayhoodOptions} boomCoverOptions={this.BoomCoverOptions} />} />
                <Route path="/x43/wheel" render={(props) => <X43Wheel {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} wheelOptions={this.WheelOptions} />} />
                <Route path="/x43/mast" render={(props) => <X43Mast {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} mastAndBoomOptions={this.MastAndBoomOptions} />} />

                <Route path="/x43/surfaces" render={(props) => <X43Interior {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} veneerOptions={this.VeneerOptions} floorboardOptions={this.FloorboardOptions} handrailOptions={this.HandrailOptions} />} />
                <Route path="/x43/saloon" render={(props) => <X43Saloon {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} />} />
                <Route path="/x43/fabric" render={(props) => <X43Fabric {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} fabricOptions={this.FabricOptions} />} />
                <Route path="/x43/galley" render={(props) => <X43Galley {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} worktopOptions={this.WorktopOptions} />} />
                <Route path="/x43/aftcabin" render={(props) => <X43AftCabin {...props} onChange={this.handleInteriorConfigurationChange} fabricOptions={this.FabricOptions} configuration={this.state.interior} aftCabinOptions={this.AftCabinLayoutOptions} />} />
                <Route path="/x43/ownerscabin" render={(props) => <X43OwnersCabin {...props} onChange={this.handleInteriorConfigurationChange} fabricOptions={this.FabricOptions} configuration={this.state.interior} />} />

                <Route path="/x43/summary" render={(props) => <X43Summary {...props} country={this.state.country} countries={this.state.countries} code={this.generateCode()} configuration={{ exterior: this.state.exterior, interior: this.state.interior, transom: this.state.transom }} />} />
            </Switch>
        );
    }
}

export default withTranslation()(X43Container);


// WEBPACK FOOTER //
// ./src/X43/X43Container.js